export default __webpack_public_path__ + "static/media/image-blue.4185e18c.svg";